import { Component, Input } from '@angular/core';
import { Packet } from '../../models/packet';
import { SharedService } from '../../services/shared.service';

/** 스타일이 중복되서 event style 사용 */
@Component({
  selector: '[appointment-packet]',
  templateUrl: './appointment-packet.component.html',
  styleUrls: ['./appointment-event.component.scss'],
})

export class AppointmentPacket {

  /**
   * 프로그램 명
   * @type {string}
   */
  program: string = '';

  /**
   * 횟수
   * @type {string}
   */
  time: string = '';

  constructor() {}

  @Input('packet') set packet(pkt: Packet) {
    if (pkt) {
      this.program  = pkt.program;
    }
  }

  @Input('date') set date(d: Date) {
    if (d) {
      const h = d.getHours();
      const prefix = d.getHours() >= 12 ? '오후' : '오전';
      const hour = SharedService.addZero(d.getHours() > 12 ? h - 12 : h);
      const min = SharedService.addZero(d.getMinutes());
      this.time = `${prefix} ${hour}:${min}`;
    }
  }
}
